var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 7, md: 9, sm: 12, span: 6, xl: 6, xs: 24 } },
            [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { alt: "", src: "images/jiadian_shorthight.png" },
              }),
            ]
          ),
          _c(
            "el-col",
            { attrs: { lg: 16, md: 14, sm: 12, span: 18, xl: 18, xs: 24 } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c("h2", [_vm._v("太保家电雇主险短期+24小时-高空")]),
                  _c("div", [
                    _vm._v("行业首选方案 | 中国太平洋产险承保 | 不限厂商品牌"),
                  ]),
                  _c("p", [
                    _vm._v(
                      "\n\t\t\t\t\t① 灵活投保，可选1-3月方案，适用临时用工\n\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t② 人性关怀，扩展24小时意外，非工作意外也保障\n\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t③ 保障充足，100/120万方案可选，保障覆盖全面\n\t\t\t\t\t"
                    ),
                    _c("br"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "warning" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleInsure.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("立即投保")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "保险详情", name: "0" } },
            [
              _c(
                "el-card",
                [
                  _c("avue-crud", {
                    ref: "crud",
                    attrs: {
                      "cell-style": _vm.onCellStyle,
                      data: _vm.dataPlan,
                      option: _vm.optionPlan,
                      "span-method": _vm.spanMethodPlan,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "赔付标准" } },
                [
                  _c("el-row", { attrs: { justify: "center", type: "flex" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          "margin-bottom": "20px",
                        },
                      },
                      [
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "医疗费用：医保范围，含合理必须的自费药，100%赔付。"
                          ),
                        ]),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "误工费：包含住院期间以及出院后的休息误工时间，180天为限。"
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c(
                    "avue-crud",
                    {
                      ref: "crud",
                      attrs: {
                        data: _vm.dataBenefit,
                        option: _vm.optionBenefit,
                      },
                    },
                    [_c("template", { slot: "header" })],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "常见问题", name: "1" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "ul",
                      _vm._l(_vm.dataQA, function (ref) {
                        var question = ref.question
                        if (question === void 0) question = ""
                        var answer = ref.answer
                        if (answer === void 0) answer = ""
                        return _c(
                          "li",
                          { key: question },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    width: "20px",
                                    "text-align": "center",
                                    "background-color": "MediumPurple",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tQ\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(question))]
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "margin-top": "12px",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      width: "20px",
                                      height: "28px",
                                      "background-color": "MediumSeaGreen",
                                      color: "white",
                                      padding: "4px",
                                      "border-radius": "4px",
                                      "margin-right": "8px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t\t"
                                    ),
                                  ]
                                ),
                                question ===
                                "中途是否可以加人？新增人员如何收费？"
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t中途可以增加保障人员。保单新增人员时，保费按照剩余的保险月数进行计费，不足一个月的按照一个月计算。\n\t\t\t\t\t\t\t\t\t"
                                        ),
                                        _c(
                                          "table",
                                          {
                                            staticStyle: { margin: "15px" },
                                            attrs: {
                                              border: "1",
                                              cellpadding: "0",
                                              ellspacing: "0",
                                              width: "100%",
                                            },
                                          },
                                          [
                                            _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                _c("th", [_vm._v("剩余月数")]),
                                                _vm._l(12, function (item) {
                                                  return _c("th", [
                                                    _vm._v(
                                                      _vm._s(item) + "个月"
                                                    ),
                                                  ])
                                                }),
                                              ],
                                              2
                                            ),
                                            _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                _c("td", [_vm._v("支付比例")]),
                                                _vm._l(
                                                  _vm.questionDataRate,
                                                  function (item) {
                                                    return _c("td", [
                                                      _vm._v(_vm._s(item)),
                                                    ])
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t保单2021年4月30日24点到期，批增人员2020年5月15日起保按照年度保费的100%收取，若批增人员在6月1日起保按照年度保费的95%收取。\n\t\t\t\t\t\t\t\t"
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "white-space": "pre-wrap",
                                        },
                                      },
                                      [_vm._v(_vm._s(answer))]
                                    ),
                              ]
                            ),
                            _c("el-divider"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "投保须知", name: "2" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "line-height": "26px",
                          "white-space": "pre-line",
                        },
                      },
                      [
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t本产品由中国太平洋财产保险股份有限公司（以下简称“太平洋产险”）承保，由太平洋产险委托博维保险经纪有限公司（以下简称“博维”）进行销售\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。\n\t\t\t\t\t\t太平洋产险成立于1991年，总部设在上海，注册资本为人民币194.70亿元。公司在拥有41家分公司，1家航运保险事业营运中心。截至2022年2季度，公司综合偿付能力充足率225.2%，满足监管要求，最近一期的风险综合评级结果为AA。\n\t\t\t\t\t\t"
                        ),
                        _c("h3", [_vm._v("一、重要告知")]),
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t1.1 订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。 1.2\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t1.3 保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。 1.4\n\t\t\t\t\t\t\t如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。\n\t\t\t\t\t\t\t1.5\n\t\t\t\t\t\t\t如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。\n\t\t\t\t\t\t\t1.6\n\t\t\t\t\t\t\t如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，但应当退还保险费。\n\t\t\t\t\t\t\t1.7\n\t\t\t\t\t\t\t保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("h3", [_vm._v("二、产品信息")]),
                        _c(
                          "table",
                          {
                            staticStyle: { margin: "15px" },
                            attrs: {
                              border: "1",
                              cellpadding: "0",
                              ellspacing: "0",
                              width: "100%",
                            },
                          },
                          [
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticStyle: {
                                    width: "50%",
                                    padding: "5px 0",
                                  },
                                },
                                [_vm._v("备案名称")]
                              ),
                              _c(
                                "th",
                                {
                                  staticStyle: {
                                    width: "50%",
                                    padding: "5px 0",
                                  },
                                },
                                [_vm._v("注册号")]
                              ),
                            ]),
                            _c(
                              "tr",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c(
                                  "td",
                                  { staticStyle: { padding: "5px 0" } },
                                  [
                                    _vm._v(
                                      "中国太平洋财产保险股份有限公司雇主责任保险（2016版）条款"
                                    ),
                                  ]
                                ),
                                _c(
                                  "td",
                                  { staticStyle: { padding: "5px 0" } },
                                  [_vm._v("C00001430912016110806772")]
                                ),
                              ]
                            ),
                            _c(
                              "tr",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c(
                                  "td",
                                  { staticStyle: { padding: "5px 0" } },
                                  [
                                    _vm._v(
                                      "中国太平洋财产保险股份有限公司雇主责任保险附加法律费用额外增加条款"
                                    ),
                                  ]
                                ),
                                _c(
                                  "td",
                                  { staticStyle: { padding: "5px 0" } },
                                  [_vm._v("H00001430922017052494811")]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c("h3", [_vm._v("三、产品介绍")]),
                        _c("h4", [_vm._v("3.1 投保人/被保险人")]),
                        _vm._v(
                          "\n\t\t\t\t\t\t售后服务网点（单位）为保险合同的投保人/被保险人。\n\t\t\t\t\t\t"
                        ),
                        _c("h4", [_vm._v("3.2 保险期限")]),
                        _vm._v(
                          "\n\t\t\t\t\t\t自所投保雇主责任保险生效日起，保险期限为一年。\n\t\t\t\t\t\t"
                        ),
                        _c("h4", [_vm._v("3.3 特别约定")]),
                        _vm._v(
                          "\n\t\t\t\t\t\t3.3.1在保险期间内，被保险人的在保雇员因从事被保险人所安排的企业经营范围内的工作（不限家电品牌、品类）而遭受意外事故，所致伤、残或死亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照保险合同约定在赔偿限额内负责赔偿。\n\t\t\t\t\t\t3.3.2本保单保障项目分为死亡赔偿、伤残赔偿、医疗费用、误工费、法律费用，每项保障项目的赔偿限额以保单载明为准。\n\t\t\t\t\t\t3.3.3本保单的共同被保险人包括保单约定的被保险人及其分销商、二级网点，应在投保时列明在保单中。对于未列明的，在理赔时需要提供与被保险人的相关合作协议、银行结算清单等关系证明材料，如不能提供证明材料的则不视为共同被保险人。\n\t\t\t\t\t\t3.3.4本保单采用记名承保，可承保人员包括正式在册职工、短期工、临时工、季节工、学徒工、负责人、法人代表和个体工商户经营者本人。\n\t\t\t\t\t\t3.3.5鉴于被保险人的行业风险特性，本保单所定的保险费率已为最低收费，即短期保费等于保单保费。本保单申请退保可退保费为0，本保单不可进行人员批增、替换和批减。\n\t\t\t\t\t\t3.3.6被保险人须按投保雇员实际工作中危险程度最高的情况选择投保方案，若被保险人的在保雇员在发生保险事故时实际工作的危险程度高于投保方案适用情况的，保险人将不承担任何赔偿责任。\n\t\t\t\t\t\t3.3.7\n\t\t\t\t\t\t国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业”。保险人仅对投保高空方案的被保人员承担高处作业的保险责任，投保高空方案的在保雇员从事高处作业发生的保险事故，保险人按照保险合同约定在赔偿限额内负责赔偿。\n\t\t\t\t\t\t3.3.8鉴于家电售后移动作业的行业特性，被保险人须在发生保险事故48小时内向保险人报案，且须提供包含派工单位、服务人员、服务时间、用户姓名、联系电话、服务地址等信息在内的不可逆的真实派工记录。否则，保险人有权拒赔或对无法核实保险责任的损失不承担赔偿责任。\n\t\t\t\t\t\t3.3.9被保险人的在保雇员从事高处作业时，因未系挂安全带导致的死亡事故，须免赔10%。\n\t\t\t\t\t\t3.3.10在保险期间内，发生保险责任范围内的保险事故，导致在保雇员死亡或伤残，保险人按下列标准赔偿：\n\t\t\t\t\t\t死亡：依据国家规定的工伤死亡赔偿标准计算，并在保单约定的死亡赔偿限额内赔偿。\n\t\t\t\t\t\t伤残：根据伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）（以下称《伤残鉴定标准》）确定伤残等级后，依据国家及当地社保部门规定的工伤伤残赔偿标准计算，并在保单约定的伤残赔偿限额内赔偿。保单约定的伤残赔偿以死亡、伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例为限。为确保伤残鉴定结果准确无争议，在进行伤残鉴定前被保险人应提前联系保险人，确定保险人认可的伤残鉴定机构。对于伤残鉴定结果存在争议的，被保险人应前往当地劳动保障行政部门或保险人认可的伤残鉴定机构重新进行伤残鉴定。\n\t\t\t\t\t\t3.3.11本保单特约伤残等级赔付限额比例：一级100%；二级90%；三级80%；四级70%；五级60%；六级50%；七级40%；八级30%；九级20%；十级10%。伤残项目对应《伤残鉴定标准》两项者，如果两项不同级，以级别高者确定伤残等级，如果两项同级，以该级别的上一等级确定伤残等级；伤残项目对应《伤残鉴定标准》三项以上者（含三项），以所有伤残项目中最高级别的上一等级确定伤残等级。但无论如何，伤残等级不得高于《伤残等级赔偿限额比例表》中所规定的一级。\n\t\t\t\t\t\t3.3.12医疗机构特别约定：本保单认可的医疗机构指经中华人民共和国卫生部门评审确定的二级或二级以上的医院，但不包括主要作为诊所、康复、护理、休养、静养、戒酒、戒毒等或类似的医疗机构。该医院必须具有符合国家有关医院管理规则设置标准的医疗设备，且全天二十四小时有合格医师及护士驻院提供医疗及护理服务。如因紧急抢救无法前往本保单指定的定点医院救治的，应在情况允许的条件下，于72小时内转入本保单认可的医疗机构就诊。\n\t\t\t\t\t\t3.3.13医疗费用特别约定：本保单所约定的医疗费用赔偿责任仅包含在本保单认可的医疗机构发生且被保险人实际支出的，符合就诊地社会医疗保险主管部门规定的必要、合理、可报销的医疗费用，但不包括受伤人员的陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具费用。对被保险人所支出的符合本保单约定的医疗费用（包含门诊及住院）均按100%比例给付医疗保险金。如被保险人或出险人员已从其他途径获得补偿的，保险人只承担符合本保单约定的医疗费用剩余部分的保险责任。\n\t\t\t\t\t\t3.3.14自费药品赔付特别约定：本保单在医疗费用项下扩展承保合理且必要的自费药品，保单约定的每人医疗费用责任限额不变。自费药品定义为：除社保甲、乙类用药以外的，合理且必须药品的自费部分，不包括各种营养滋补类的药品、保健品。\n\t\t\t\t\t\t3.3.15误工费赔付特别约定：在保险期间内，发生保险责任范围内的保险事故，导致被保雇员暂时丧失工作能力并住院治疗的事故，经二级（含）以上或保险人认可的医疗机构提供合理的建议休息证明或由保险人依据《人身损害误工期、护理期、营养期评定规范》GA/T\n\t\t\t\t\t\t1193-2014，核定误工天数，保险人按照人民币100元/人/天的标准，以最长180天为限计算误工费。误工费计算包含住院期间以及出院后的休息误工时间，其中出院后休息误工时间取医嘱建休时间、实际误工时间及人身损害误工费评定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费计算。如经过医疗机构诊断确定为永久丧失全部/部分工作能力的，应赔付误工费与根据前述第(10)款约定所确定的伤残赔付金额合并在本保单赔偿限额内进行赔付，超出保单赔偿限额的部分保险人将不予赔付。误工费赔付无需被保险人提供出险员工的工资证明。出险员工仅在门诊治疗的，无误工费赔付。\n\t\t\t\t\t\t3.3.16扩展工伤事故：被保险人的在保雇员在工作期间，由于工作原因受到伤害，依照《工伤保险条例》应当认定为工伤或视同工伤时，对于被保险人依法应承担的经济赔偿责任，保险人予以赔付。\n\t\t\t\t\t\t3.3.17上下班途中扩展：兹经双方同意，对于被保险人的在保雇员在境内，不包括我国香港、澳门和台湾地区，因工外出期间由于工作原因遭受意外事故及上下班途中遭受意外事故而导致被保险人依法应承担的经济赔偿责任，保险人按照主险条款规定负责赔偿。\n\t\t\t\t\t\t3.3.18扩展法律费用条款：在保险期间内，发生可能引起本保险合同项下赔偿的情形时，被保险人被提起诉讼或仲裁，事先经保险人书面同意支付的合理的、必要的诉讼费、鉴定费、取证费、案件受理费、评估费、公证费、律师费、仲裁费及其他相关费用等，保险人依照本合同约定承担赔偿责任。保单累计赔偿限额为RMB10万元，每次事故赔偿限额为RMB10万元。\n\t\t\t\t\t\t3.3.19扩展24小时个人意外：在保险期间内，被保险人的在保雇员发生主险条款第五条约定情形以外的意外事故而导致的死亡(或自人身伤害发生之日起在180个日内发生死亡)、伤、残，保险人以主险各保障项目的赔偿限额为限承担赔偿责任。其中，伤残评定标准参照《人身保险伤残评定标准》（中保协发〔2013〕88号）评定，评定级别后赔偿金额计算标准同主险赔偿标准并以保单约定的死亡、伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例为限。本保单所载其他条件均不变。\n\t\t\t\t\t\t除外责任: 本保单对以下原因直接或间接导致被保人员死亡或人身伤害不负赔偿责任：\n\t\t\t\t\t\t(1)战争、战乱、反叛、罢工、暴乱、动乱以及核辐射等； (2)疾病、传染病、生育、怀孕、医疗以及手术等；\n\t\t\t\t\t\t(3)故意自残、自杀以及因药物或酒精导致的犯罪或失常行为； (4)打架、酗酒、吸毒、精神错乱以及高危险运动；\n\t\t\t\t\t\t高危险运动包括但不仅限于： -航空飞行，乘坐民航飞机除外； -使用呼吸器具的潜水活动；\n\t\t\t\t\t\t-足球，以业余身份参加除外； -滑翔运动； -冰上曲棍球； -摩托车竞赛； -登山、攀岩、攀崖； -跳伞；\n\t\t\t\t\t\t-地穴探险； -汽车竞赛； -以运动为职业； -滑水、跳水及水上竞技； -冬季运动，冰上溜石活动和溜冰除外；\n\t\t\t\t\t\t本附加险条款与主险条款内容相悖之处，以本附加险条款为准；未尽之处，以主险条款为准。\n\t\t\t\t\t\t"
                        ),
                        _c("h4", [_vm._v("3.4 保单形式")]),
                        _vm._v(
                          "\n\t\t\t\t\t\t本产品提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。\n\t\t\t\t\t\t"
                        ),
                        _c("h4", [_vm._v("3.5 发票形式")]),
                        _vm._v(
                          "\n\t\t\t\t\t\t本产品根据投保人的需求提供增值税普通发票（电子票）或增值税专用发票（纸质发票）。电子发票效力等同于纸质发票。\n\t\t\t\t\t\t"
                        ),
                        _c("h3", [_vm._v("四、理赔")]),
                        _vm._v(
                          "\n\t\t\t\t\t\t出险后请您尽快通过微信小程序“美保理赔助手”，或拨打博维客服热线400-180-1616进行报案，根据指引提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的损失进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。\n\t\t\t\t\t\t"
                        ),
                        _c("h3", [_vm._v("五、其他信息")]),
                        _vm._v(
                          "\n\t\t\t\t\t\t5.1\n\t\t\t\t\t\t保险人将严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，确保投保人提供的个人信息、数据和隐私不受到非法的泄露或未经投保人/被保险人同意披露给未授权的第三方。\n\t\t\t\t\t\t5.2\n\t\t\t\t\t\t若投保及后续服务和理赔过程中出现争议情况，您可致电博维客服热线400-180-1616或太平洋产险客户服务及投诉热线：95500，我们将安排专人跟进处理。\n\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }